@if (showLabel && question?.email_version) {
  <label [innerHtml]="question?.email_version"></label>
}
<div class="input-group">
  <input
    type="text"
    class="form-control"
    [disabled]="readOnly"
    [name]="uniqueControlName"
    [id]='uniqueId'
    [placeholder]="question?.question_prompt"
    [(ngModel)]="value"
    (ngModelChange)="saveValue()">
    <div class="input-group-append">
      <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
        data-trigger="focus" data-html="true" data-placement="bottom" data-original-title="" title=""
        data-content="<div class=&quot;popover__content&quot;>To change this answer you need to restart or contact us</div>">
        <svg class="icon">
          <use xlink:href="#info"></use>
        </svg>
      </a>
    </div>
  </div>
